import React from "react";
import API_URL from "../../../../config";
import { Modal, Button } from "react-bootstrap";
import moment from "moment-timezone";
import { useAuth } from "../../../../context/AuthContext";

const PagoPrintModal = ({ show, onHide, selectedPago, handlePrintAction }) => {
  const { user } = useAuth();

  // Get images from selectedPago (loaded from Tarifa via Repository)
  const logoUrl = selectedPago?.imagen_junta
    ? `${API_URL}${selectedPago.imagen_junta}`
    : null;
  const selloUrl = selectedPago?.imagen_sello
    ? `${API_URL}${selectedPago.imagen_sello}`
    : null;

  // Title from Tarifa's nombre_aplicacion
  const appTitle =
    selectedPago?.nombre_aplicacion || "SISTEMA DE GESTION DE AGUA POTABLE";

  return (
    <Modal show={show} onHide={onHide} size="md" centered>
      <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
      <Modal.Body className="p-0">
        <div
          id="comprobante-content"
          className="px-8 pt-1 pb-4 bg-white text-gray-900"
          style={{
            fontFamily: "Arial, Helvetica, sans-serif",
            fontSize: "16px",
            lineHeight: "1.2",
          }}
        >
          {/* Header Section */}
          <div className="text-center mb-1">
            {/* Logo */}
            <div className="flex justify-center mb-1">
              {logoUrl ? (
                <img
                  src={logoUrl}
                  alt="Logo Junta"
                  className="h-20 w-auto object-contain"
                />
              ) : (
                <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center">
                  <span className="text-3xl">🚰</span>
                </div>
              )}
            </div>

            {/* Title */}
            <h3 className="font-bold text-lg text-gray-900 mb-0 uppercase">
              {appTitle}
            </h3>

            {/* Comprobante No */}
            <div className="font-bold text-base mb-0">
              COMPROBANTE DE PAGO No:{" "}
              {selectedPago?.numero_comprobante ||
                selectedPago?.numeroComprobante ||
                "---"}
            </div>

            {/* Tesorero */}
            <div className="text-base text-gray-800 mb-1">
              Tesorero: {user?.nombre || "Administrador"}
            </div>

            {/* Barcode / Sello */}
            <div className="flex flex-col items-center mb-1">
              {selloUrl ? (
                <img
                  src={selloUrl}
                  alt="Código"
                  className="h-10 w-auto object-contain sello"
                />
              ) : (
                <div className="h-10 w-48 bg-gray-100 flex items-center justify-center border border-gray-200">
                  <span className="text-xs text-gray-400">SIN SELLO</span>
                </div>
              )}
            </div>
          </div>

          {/* Divider */}
          <div className="border-t border-gray-300 my-1"></div>

          {/* Data Section - Matching Legacy Format */}
          {selectedPago && (
            <div className="space-y-1 text-base">
              <div>
                <span className="font-bold">Cedula Cliente:</span>{" "}
                {selectedPago.codigo_cliente || selectedPago.cedula || "---"}
              </div>
              <div>
                <span className="font-bold">Nombre Cliente:</span>{" "}
                {(selectedPago.medidor?.cliente
                  ? `${selectedPago.medidor.cliente.nombres} ${selectedPago.medidor.cliente.apellidos}`
                  : selectedPago.nombre_cliente) || "---"}
              </div>
              <div>
                <span className="font-bold">Código de Medidor:</span>{" "}
                {selectedPago.codigo_medidor || "---"}
              </div>
              {(selectedPago.tipo_pago === "EXTRA" || selectedPago.tipo === "EXTRA") &&
                !selectedPago.is_consolidated && (
                  <div>
                    <span className="font-bold">Concepto / Deuda Extra:</span>{" "}
                    {selectedPago.descripcion || "OTROS"}
                  </div>
                )}

              {/* Detalle consolidado si existe */}
              {selectedPago.is_consolidated ? (
                <div className="mt-2 border border-gray-200 rounded p-2">
                  <div className="font-bold border-b pb-1 mb-1 text-sm bg-gray-50 px-1">
                    DETALLE DE PAGO:
                  </div>
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="border-b text-left">
                        <th className="py-1">Concepto</th>
                        <th className="py-1 text-right">Monto</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedPago.items_pagados.map((item, idx) => (
                        <tr key={idx} className="border-b last:border-0">
                          <td className="py-1">{item.descripcion}</td>
                          <td className="py-1 text-right font-medium">
                            ${Number(item.monto).toFixed(2)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <>
                  {selectedPago.tipo_pago !== "EXTRA" && selectedPago.tipo !== "EXTRA" && (
                    <>
                      <div>
                        <span className="font-bold">Lectura Anterior:</span>{" "}
                        {selectedPago.lecturas?.anterior ??
                          selectedPago.lectura_anterior ??
                          0}
                      </div>
                      <div>
                        <span className="font-bold">Lectura Actual:</span>{" "}
                        {selectedPago.lecturas?.actual ??
                          selectedPago.lectura_actual ??
                          0}
                      </div>
                      <div>
                        <span className="font-bold">Consumo m³:</span>{" "}
                        {selectedPago.consumos?.m3 ?? selectedPago.consumo ?? 0}
                      </div>
                      <div>
                        <span className="font-bold">Exceso m³:</span>{" "}
                        {selectedPago.consumos?.excesoM3 ??
                          selectedPago.exceso ??
                          0}
                      </div>
                    </>
                  )}

                  <div>
                    <span className="font-bold">
                      {selectedPago.tipo_pago === "EXTRA" || selectedPago.tipo === "EXTRA"
                        ? "Período / Mes:"
                        : "Mes Consumo:"}
                    </span>{" "}
                    {selectedPago.mes || "---"}
                  </div>

                  {selectedPago.tipo_pago !== "EXTRA" && selectedPago.tipo !== "EXTRA" && (
                    <>
                      <div>
                        <span className="font-bold">Exceso ($):</span>{" "}
                        {Number(
                          selectedPago.valores?.valorExceso ??
                            selectedPago.valor_exceso ??
                            0,
                        ).toFixed(2)}
                      </div>
                      <div>
                        <span className="font-bold">Mora ($):</span>{" "}
                        {Number(
                          selectedPago.valores?.mora ?? selectedPago.mora ?? 0,
                        ).toFixed(2)}
                      </div>
                      <div>
                        <span className="font-bold">Reconexión ($):</span>{" "}
                        {Number(selectedPago.valores?.reconexion ?? 0).toFixed(
                          2,
                        )}
                      </div>
                      <div className="pt-1 border-t border-gray-100 mt-1">
                        <span className="font-bold text-gray-800">
                          Subtotal Agua ($):
                        </span>{" "}
                        {Number(
                          (selectedPago.valores?.total ||
                            selectedPago.total_pagar ||
                            0) -
                            (selectedPago.valores?.deuda_extra ||
                              selectedPago.deuda_extra ||
                              0),
                        ).toFixed(2)}
                      </div>
                    </>
                  )}

                  {/* Deuda Extra - NEW */}
                  {Number(
                    selectedPago.valores?.deuda_extra ??
                      selectedPago.deuda_extra ??
                      0,
                  ) > 0 && (
                    <div className="font-bold text-gray-800">
                      <span>Deudas Extras ($):</span>{" "}
                      {Number(
                        selectedPago.valores?.deuda_extra ||
                          selectedPago.deuda_extra ||
                          0,
                      ).toFixed(2)}
                    </div>
                  )}
                </>
              )}

              <div className="pt-1">
                <span className="font-bold">Fecha de Pago:</span>{" "}
                {moment(
                  selectedPago.pagadoEn ||
                    selectedPago.fecha_pago ||
                    new Date(),
                ).format("DD/MM/YYYY HH:mm:ss")}
              </div>
              <div className="font-bold text-lg pt-2 border-t border-dashed border-gray-400 mt-2">
                <span>TOTAL PAGADO:</span> $
                {Number(
                  selectedPago.is_consolidated
                    ? selectedPago.items_pagados.reduce((acc, item) => acc + Number(item.monto), 0)
                    : (selectedPago.valores?.total ??
                      selectedPago.total_pagar ??
                      selectedPago.consumo_total ??
                      0)
                ).toFixed(2)}
              </div>
            </div>
          )}

          {/* Footer */}
          <div className="mt-2 pt-2 border-t border-gray-200 text-center">
            <p className="mb-0">
              Para revisar los consumos pendientes de tu cuenta, visita:
            </p>
            <p className="font-bold text-gray-900 mb-0">
              www.juntadeaguapotable.com
            </p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="bg-white border-t border-gray-200 justify-between px-6">
        <Button
          variant="secondary"
          onClick={onHide}
          className="px-6 py-2 bg-gray-200 text-gray-700 border-0 rounded-lg hover:bg-gray-300"
        >
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={handlePrintAction}
          className="px-6 py-2 bg-blue-600 text-white border-0 rounded-lg hover:bg-blue-700"
        >
          Imprimir
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PagoPrintModal;
